import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './MultiplayerLobby.css';

const KBCChallengeReceiver = ({ userName, onChallengeAccepted }) => {
  const [challenges, setChallenges] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchChallenges();
    const interval = setInterval(fetchChallenges, 3000);
    return () => clearInterval(interval);
  }, [userName]);

  const fetchChallenges = async () => {
    try {
      const response = await axios.get(`/api/kbc-challenges/${encodeURIComponent(userName)}`);
      setChallenges(response.data);
    } catch (error) {
      console.error('Error fetching challenges:', error);
    }
  };

  const acceptChallenge = async (challenge) => {
    setLoading(true);
    try {
      const response = await axios.post('/api/kbc-challenges/accept', {
        requestId: challenge._id,
        challenger: challenge.fromPlayer,
        challenged: userName,
        questions: challenge.questions,
        gameConfig: challenge.gameConfig
      });

      if (response.data.success) {
        // Remove the accepted challenge
        await axios.delete(`/api/kbc-challenges/${challenge._id}`);
        
        // Start the game
        onChallengeAccepted({
          mode: 'kbc-host-contestant',
          questions: challenge.questions,
          gameSession: response.data.gameSession
        });
      }
    } catch (error) {
      console.error('Error accepting challenge:', error);
      alert('Failed to accept challenge');
    } finally {
      setLoading(false);
    }
  };

  const rejectChallenge = async (challengeId) => {
    try {
      await axios.delete(`/api/kbc-challenges/${challengeId}`);
      setChallenges(challenges.filter(c => c._id !== challengeId));
    } catch (error) {
      console.error('Error rejecting challenge:', error);
    }
  };

  if (challenges.length === 0) {
    return null; // Don't show anything if no challenges
  }

  return (
    <div style={{
      position: 'fixed',
      top: '20px',
      right: '20px',
      background: 'white',
      border: '3px solid #f59e0b',
      borderRadius: '12px',
      padding: '20px',
      boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
      zIndex: 1000,
      minWidth: '300px',
      maxWidth: '400px'
    }}>
      <h3 style={{ margin: '0 0 15px 0', color: '#f59e0b' }}>
        🎯 KBC Challenge Received!
      </h3>
      
      {challenges.map(challenge => (
        <div key={challenge._id} style={{
          background: '#fef3c7',
          padding: '15px',
          borderRadius: '8px',
          marginBottom: '15px',
          border: '1px solid #f59e0b'
        }}>
          <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>
            From: {challenge.fromPlayer}
          </div>
          <div style={{ fontSize: '14px', color: '#92400e', marginBottom: '10px' }}>
            📚 {challenge.gameConfig?.subject || 'Mixed'} • 
            🎓 Class {challenge.gameConfig?.class || 'All'} • 
            📝 {challenge.questions?.length || 12} Questions
          </div>
          <div style={{ fontSize: '12px', color: '#78350f', marginBottom: '15px' }}>
            No time limit • Timer sounds for ambiance
          </div>
          
          <div style={{ display: 'flex', gap: '10px' }}>
            <button
              onClick={() => acceptChallenge(challenge)}
              disabled={loading}
              style={{
                flex: 1,
                background: '#10b981',
                color: 'white',
                padding: '10px',
                border: 'none',
                borderRadius: '6px',
                cursor: loading ? 'not-allowed' : 'pointer',
                opacity: loading ? 0.6 : 1
              }}
            >
              {loading ? 'Accepting...' : 'Accept Challenge'}
            </button>
            <button
              onClick={() => rejectChallenge(challenge._id)}
              disabled={loading}
              style={{
                background: '#ef4444',
                color: 'white',
                padding: '10px 15px',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer'
              }}
            >
              ✕
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default KBCChallengeReceiver;